import WavesLadderSvg from '@assets/images/svg/waves-ladder.svg';
import React from 'react';
import { View } from 'react-native';

export interface WavesLadderIconProps {
    size?: number;
    color?: string;
}

export function WavesLadderIcon({ size = 25, color = '#4D4D4D' }: WavesLadderIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <WavesLadderSvg width={size} height={size} color={color} />
        </View>
    );
}

export default WavesLadderIcon;
